<template>
	<div>
		<svg
			v-if="isActive"
			:width="size"
			:height="size"
			viewBox="0 0 20 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.39497 17.9107L9.38844 17.9072L9.36579 17.8949C9.3465 17.8844 9.31891 17.8693 9.28358 17.8496C9.21292 17.8101 9.11124 17.7524 8.98296 17.6769C8.7265 17.5261 8.36317 17.3039 7.92855 17.015C7.06074 16.4381 5.90122 15.5901 4.7386 14.5063C2.43781 12.3615 0 9.1751 0 5.25C0 2.32194 2.4636 0 5.4375 0C7.18638 0 8.75232 0.799088 9.75 2.0516C10.7477 0.799088 12.3136 0 14.0625 0C17.0364 0 19.5 2.32194 19.5 5.25C19.5 9.1751 17.0622 12.3615 14.7614 14.5063C13.5988 15.5901 12.4393 16.4381 11.5715 17.015C11.1368 17.3039 10.7735 17.5261 10.517 17.6769C10.3888 17.7524 10.2871 17.8101 10.2164 17.8496C10.1811 17.8693 10.1535 17.8844 10.1342 17.8949L10.1116 17.9072L10.105 17.9107L10.1023 17.9121C9.88231 18.0289 9.61769 18.0289 9.39773 17.9121L9.39497 17.9107Z"
				:fill="color"
			/>
		</svg>
		<svg
			v-else
			:width="size"
			:height="size"
			viewBox="0 0 20 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.75 5.25C18.75 2.76472 16.6513 0.75 14.0625 0.75C12.1269 0.75 10.4653 1.87628 9.75 3.48342C9.03472 1.87628 7.37312 0.75 5.4375 0.75C2.84867 0.75 0.75 2.76472 0.75 5.25C0.75 12.4706 9.75 17.25 9.75 17.25C9.75 17.25 18.75 12.4706 18.75 5.25Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgHearth',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
